<div class="sidebar menuimg_sidebar">
    <ng-container *ngFor="let place of places">
        <a *ngIf="place.isVisible">
            <div class="{{place.moduleName}} indvPlaces" (click)="changePlace(place.moduleName)"
                [ngClass]="[((selectedPlace == place.moduleName)) ? 'activeIcon' : 'defaultIcon']">
                <mat-icon class="iconimg" svgIcon="{{place.moduleName}}Icon" [attr.modulename]="place.moduleName">
                </mat-icon>
                <div class="moduleDispName">{{place.displayName}}</div>
            </div>
        </a>
    </ng-container>
    <ng-container *ngIf="commonService.isLicenseFeatureEnabled() && showLicenseAlert">
        <div class="licenseStatus" title="License expires in {{licenseDueDays}} day{{licenseDueDays === 1 ? '' : 's'}}" [ngClass]="licenseSeverityClass">
            <mat-icon class="licenseStatusIcon" svgIcon="warningFilledIcon"></mat-icon>
            <div class="licenseStatusText licenseStatusTitle">                
                <div class="licenseStatusDays" *ngIf="licenseDueDays > 0; else expiredLicenseStatus">
                   {{licenseDueDays}} day{{licenseDueDays === 1 ? '' : 's'}}
                </div>
                <ng-template #expiredLicenseStatus>
                    <div class="licenseStatusDays">Expired</div>
                </ng-template>
            </div>
        </div>
    </ng-container>
    <div *ngIf="appConfig.showAppVersion && commonService.ProjectLSData.appVersion" class="appVersion">
        v{{commonService.ProjectLSData.appVersion}}</div>
</div>